import styled from 'styled-components';

const shouldForwardProp = prop => !['isOpen'].includes(prop);

export const MedicalExpensesStyled = styled.div.withConfig({ shouldForwardProp })`
  display: flex;
  flex-direction: column;
  gap: 20px;

  .titleLine {
    background: var(--GrayScale-400);
    height: 1px;
    width: 100%;
    flex: 1;
  }
`;
